import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import bootstrap, { Modal } from 'bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NcdService } from 'src/app/services/ncd.service';
import { SocietyService } from 'src/app/services/society.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-rcs-update',
  templateUrl: './rcs-update.component.html',
  styleUrls: ['./rcs-update.component.scss']
})
export class RcsUpdateComponent {

  form!: FormGroup;
  jsonPayload: any;
  apiResponse: any;
selectedMonth: string = '';
selectedSocietyId: number | null = null;
columns1 = [

  {
    name: 'Select',
    prop: 'select',
    width: 50,
    sortable: false
  },



  {
    name: 'Society Name',
    prop: 'sSocietyName',
    width: 250,
    sortable: true
  },

  {
    name: 'Registration No.',
    prop: 'sSocietyRegistrationNo',
    width: 180,
    sortable: true
  },

  {
    name: 'District',
    prop: 'sdistrictname',
    width: 150,
    sortable: true
  },

  {
    name: 'Approval Date',
    prop: 'dtApprovedate',
    width: 150,
    sortable: true
  },

  {
    name: 'NCD Status',
    prop: 'ncdUpdated',
    width: 130,
    sortable: true
  }

];

societies: any[] = [];
  constructor(private fb: FormBuilder, private service: NcdService,  private ngxUiLoaderService: NgxUiLoaderService,
   private societyService:SocietyService,
  private toastService:ToastService){    
    this.form = this.fb.group({
      societyDetailsId: ['']
    });
    this.getAllData()
  }

//    * Step 1:
//  * Get approved societies for selected month
//  */
loadApprovedSocieties(): void {

  if (!this.selectedMonth) {
    return;
  }

  this.loading = true;

  this.societies = [];
  this.societyDetails = null;
  this.selectedSocietyId = null;

  this.jsonPayload = null;
  this.apiResponse = null;


  this.service
    .GetApprovedSocietiesByMonth(this.selectedMonth)
    .subscribe({

      next: (res: any) => {

        this.loading = false;

        if (res.status === 200 && res.data) {

          this.societies = res.data;

        } else {

          this.societies = [];

        }

      },

      error: (error) => {

        this.loading = false;

        console.error(error);

        alert('Unable to load approved societies.');

      }

    });

}
  sendSummary() {

    const id =    this.societyDetails.iSocietyDetailsId;

    // this.jsonPayload = {
    //   societyDetailsId: id
    // };
this.ngxUiLoaderService.start()
    this.service.sendCooperativeSummary(id).subscribe({
      next: (res) => {
        this.apiResponse = res;
        console.log(res)
          if(this.apiResponse?.data)
        this.jsonPayload = JSON.parse(this.apiResponse?.data)
        if(this.apiResponse?.message)
        this.apiResponse = JSON.parse(this.apiResponse?.message);
// this.loadApprovedSocieties();
if(this.apiResponse.status=='error'){
this.toastService.showError(this.apiResponse?.errors[0].message)
}else{
  this.loadApprovedSocieties();
this.toastService.showSuccess(this.apiResponse?.message)
}
 

        this.ngxUiLoaderService.stop();
      },
      error: (err) => {
              this.ngxUiLoaderService.stop();
        this.apiResponse = err;
        // this.loadApprovedSocieties()
        // this.toastService.showError(this.apiResponse?.message)
      }
    });
  }

  

    getAllData() {
      //this.loading = true;
      this.ngxUiLoaderService.start()
      this.societyService.getSocietyTabsData('', 0).subscribe({
        next: (response) => {
          this.ngxUiLoaderService.stop();
          //this.loading = false;
          console.log(response)
          if (response.status === 200) {
          
        }
        
      },
        error: (error) => {
          this.ngxUiLoaderService.stop()
          console.log(error);
          
          // this.toastService.showError(error.message);
        },
      });
    }

  softDelete() {

    const id = this.form.value.societyDetailsId;

  this.ngxUiLoaderService.start()

    this.service.softDeleteSocietySummary(id).subscribe({
      next: (res) => {
        this.apiResponse = res;
        
            if(this.apiResponse?.data)
        this.jsonPayload = JSON.parse(this.apiResponse?.data)
        if(this.apiResponse?.message)
        this.apiResponse = JSON.parse(this.apiResponse?.message);

              this.ngxUiLoaderService.stop();
      },
      error: (err) => {
        this.apiResponse = err;
              this.ngxUiLoaderService.stop();
      }
    });
  }

  societyDetails: any = null;


loading = false;


selectSociety(society:any): void {

  const societyDetailsId =    society.sRegisrtartionNo;


  if (!societyDetailsId) {
    alert('Please enter Society Details ID');
    return;
  }

  this.loading = true;

  this.jsonPayload = null;
  this.apiResponse = null;
  this.societyDetails = null;

  const request = {
    sRegistartionNo: societyDetailsId.toString()
  };

  this.service.getSocietyDetailsRegistationNo(request).subscribe({

    next: (res: any) => {

      this.loading = false;

      if (res.status === 200 && res.data?.length > 0) {

        this.societyDetails = res.data[0];

      } else {

        alert('No society details found.');

      }

    },

    error: (error) => {

      this.loading = false;

      console.error(error);

      alert('Unable to get society details.');

    }

  });

}


/**
 * Open confirmation popup before sending to NCD
 */
confirmSendSummary(): void {

  if (!this.societyDetails) {
    alert('Please get society details first.');
    return;
  }

this.openModal('ncdUpdateConfirmModal')

}
  openModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.show();

    }
  }

  hideModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.hide();
    }
  }

/**
 * Send data to NCD after user confirmation
 */
// sendSummary(): void {

//   if (!this.societyDetails) {
//     alert('Please get society details first.');
//     return;
//   }


//   /*
//    * Create NCD payload here.
//    *
//    * Map your ShowSocietyDetails object
//    * to the exact NCD API contract.
//    */

//   const payload = {

//     societyDetailsId:
//       this.societyDetails.iSocietyDetailsId,

//     societyUserId:
//       this.societyDetails.iSocietyUserId,

//     societyId:
//       this.societyDetails.iSocietyId,

//     societyName:
//       this.societyDetails.sSocietyName,

//     registrationNo:
//       this.societyDetails.sSocietyRegistrationNo,

//     registrationNoNcd:
//       this.societyDetails.SRegisrtartionNo,

//     address:
//       this.societyDetails.Address ||
//       this.societyDetails.sAddress1,

//     mobile:
//       this.societyDetails.Mobile,

//     email:
//       this.societyDetails.Email,

//     division:
//       this.societyDetails.sdivisionname,

//     district:
//       this.societyDetails.sdistrictname,

//     circle:
//       this.societyDetails.scirclename,

//     block:
//       this.societyDetails.sblockname,

//     panchayat:
//       this.societyDetails.spanchayatname,

//     village:
//       this.societyDetails.svillagename,

//     category:
//       this.societyDetails.scategoryname,

//     kind:
//       this.societyDetails.ssocietykindname,

//     type:
//       this.societyDetails.ssocietytypename,

//     areaOperation:
//       this.societyDetails.sareaoperationname,

//     pincode:
//       this.societyDetails.sPincode,

//     shareValue:
//       this.societyDetails.shareValue,

//     totalAmount:
//       this.societyDetails.totalAmount

//   };


//   // Show exactly what is being sent
//   this.jsonPayload = payload;

//   this.loading = true;


//   this.service.sendSummary(payload).subscribe({

//     next: (res: any) => {

//       this.loading = false;

//       // Show NCD response
//       this.apiResponse = res;

//     },

//     error: (error) => {

//       this.loading = false;

//       console.error(error);

//       this.apiResponse = error;

//     }

//   });

// }

}
